
define('text!libs/strand/src/strand-timepicker/example.html',[],function () { return '<strand-timepicker></strand-timepicker>\n\n<strand-timepicker use24-hour-time></strand-timepicker>\n';});

